import React, { useEffect } from 'react'
import { Moment } from 'moment'
import { Error } from 'components/common'
import { BookingStatusTable } from 'components/bookings'
import {
  useBookingStatusOfTheDayQuery,
  useOrderQuery,
} from 'lib/graphql/storeadmin'
import { useOrderForObserverQuery } from 'lib/graphql/observer'
import { PageProps } from 'gatsby'

type DailyTableType = {
  currentDate: Moment
  page: PageProps<Queries.Query>
  isObserver?: boolean
}

const DailyTable = ({ currentDate, page, isObserver }: DailyTableType) => {
  const { data, loading, error, refetch } = useBookingStatusOfTheDayQuery({
    variables: { input: { date: currentDate.format('YYYY-MM-DD') } },
  })
  const orderQueryHook = isObserver ? useOrderForObserverQuery : useOrderQuery
  const {
    data: orderData,
    refetch: orderRefetch,
    loading: orderLoading,
  } = orderQueryHook({
    variables: { id: '' },
  })

  useEffect(() => {
    refetch({ input: { date: currentDate.format('YYYY-MM-DD') } })
  }, [currentDate, refetch, page.location])

  const getOrderData = (orderId: string) => {
    orderRefetch({ id: orderId })
  }

  if (error) {
    return Error.render(error)
  }

  return (
    <>
      <BookingStatusTable
        data={data}
        orderData={orderData}
        orderLoading={orderLoading}
        getOrderData={getOrderData}
        loading={loading}
      />
    </>
  )
}

export default DailyTable
